import React from "react";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import OurStory from "./components/OurStory";
import Concept from "./components/Concept";
import Scroll from "../Header/Scroll";
import Image from "../../images/banner2.jpg";
import Image2 from "../../images/background2.jpg";
import Clients from "./components/Clients";
import Process from "./components/Process";
import Products from "./components/Products";
import Approach from "../../components/Services/components/Approach";
import Whatsapp from "../Footer/Whatsapp";

const styles = {
  paperContainer: {
    height: 800,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styles2 = {
  paperContainer: {
    height: 200,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Home = () => {
  return (
    <Box>
      <Scroll>
        <AppBar position={"fixed"} elevation={0}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box display={{ xs: "none", sm: "inline" }} id="back-to-top-anchor">
        <Banner />
      </Box>
      <Box style={styles.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Banner />
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <OurStory />
        </Container>
      </Box>
      <Box style={styles2.paperContainer}></Box>
      <Box>
        <Container>
          <Process />
        </Container>
      </Box>
      <Box>
        <Container>
          <Concept />
        </Container>
      </Box>
      <Box>
        <Container>
          <Approach />
        </Container>
      </Box>
      <Box>
        <Container>
          <Products />
        </Container>
      </Box>
      <Box>
        <Container>
          <Clients />
        </Container>
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <Footer />
        </Container>
      </Box>
      <Whatsapp />
    </Box>
  );
};

export default Home;
